/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { buttonVariantsStyles } from '@/styles/Default/Button/variantsStyles';

import { getStyleOverrides } from '@/utils/getStyleOverrides';
import { ThemeOptions } from '@mui/material/styles';
import { buttonVariants } from './variants';

export const Button: ThemeOptions = {
	components: {
		MuiButtonBase: {
			defaultProps: {
				// The props to change the default for.
				disableRipple: true, // No more ripple, on the whole application 💣!
			},
		},
		MuiButton: {
			variants: buttonVariants,
			styleOverrides: {
				root: getStyleOverrides({
					styles: {
						py: 1.25,
						px: 2.5,
						minWidth: 'auto',
						fontWeight: 700,
						boxShadow: 'none',
						borderRadius:'5px',
						'&:focus-visible':{ // focus-visible is activated only when element is focussed using keyboard
							outlineOffset: 4,
							borderRadius: 0.1,
							outline:'2px solid #000'
						}
					},
					variants: buttonVariantsStyles,
				}),
				contained: getStyleOverrides({
					styles: {
						backgroundColor: 'button.primaryBackground',
						color: 'button.primary',
						paddingBottom:'12px',
						'&:hover': {
							backgroundColor: 'button.primaryHover',
							boxShadow: 'none',
						},
					},
				}),
				containedSuccess: getStyleOverrides({
					styles: {
						backgroundColor: 'button.primaryCheckout',
						color: 'button.secondary',
						'&:hover': {
							backgroundColor: 'button.primaryCheckoutHover',	
						},
					},
				}),
				outlined: getStyleOverrides({
					styles: {
						backgroundColor: 'button.secondaryBackground',
						color: 'button.secondary',
						borderColor: 'button.secondary',
						borderWidth: '2px',
						'&:hover': {
							backgroundColor: 'button.secondaryBackground',
							color: 'button.secondary',
							borderColor: 'button.secondary',
							borderWidth: '2px',
						},
					},
				}),
				text: getStyleOverrides({
					styles: {
						boxShadow: 'none',
						minWidth: 'unset',
						color: 'primary.main',
						'&:hover': {
							color: 'primary.dark',
						},
					},
				}),				
			},
		},
	},
};
